import { render, staticRenderFns } from "./CRow.vue?vue&type=template&id=ccf4ee12&scoped=true&"
import script from "./CRow.vue?vue&type=script&lang=ts&"
export * from "./CRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf4ee12",
  null
  
)

export default component.exports